function buildCarePlanCopyPayload(careplancontext) {
    let output = '';
    careplancontext.categories.forEach(category => {
        const headerText = careplancontext.$t(careplancontext.getHeaderToken(category));
        const contentList = careplancontext.getContentList(category);
        if (!contentList.length) return;
        output += formatSectionHeader(headerText);
        contentList.forEach(item => {
            if (category === 'medication') {
                // Default message (no treatments selected)
                const isDefaultMessage = !item.name && item.headerToken && !item.detailContent;
                if (isDefaultMessage) {
                    output += `${careplancontext.$t(item.headerToken)}\n`;
                } else if (item.headerToken) {
                    output += `${careplancontext.$t(item.headerToken)}\n`;
                } else if (item.name) {
                    output += `  ${item.name}\n`;
                }
                if (item.detailContent && Array.isArray(item.detailContent)) {
                    item.detailContent.forEach(line => {
                        output += `  • ${careplancontext.$t(line)}\n`;
                    });
                }
            } else {
                if (item.subHeaderToken) {
                    output += `  ${careplancontext.$t(item.subHeaderToken)}\n`;
                }
                if (item.detailContent && Array.isArray(item.detailContent)) {
                    item.detailContent.forEach(line => {
                        output += `  • ${careplancontext.$t(line)}\n`;
                    });
                }
            }
        });
        output += '\n';
    });
    return output.trim();
}

function formatSectionHeader(typeLabel) {
    const label = typeLabel.toUpperCase();
    return `${label}\n${'='.repeat(label.length)}\n`;
}

export { buildCarePlanCopyPayload };